import { SocialPlatform, socialPlatforms } from '../domain/platforms';

/** Returns all registered social export platforms. */
export function useEnabledSocialPlatforms(): SocialPlatform[] {
  return socialPlatforms.all();
}
